import { Component } from '@angular/core';
import {Router,Event,NavigationStart,NavigationEnd, RouterEvent} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'webapp';
  showLoading=false;
  constructor(private _router:Router){
    this._router.events.subscribe((routerEvent:Event)=>{
      if(routerEvent instanceof NavigationStart){
        this.showLoading=true;
      }

      if(routerEvent instanceof NavigationEnd)
      {
        this.showLoading=false;
      }
    });

  }

}
